import React, { memo } from "react";
import { Link } from "react-router-dom";
import { Button, Icon } from "@mui/material";
import { LaptopOutlined } from "@mui/icons-material";
import ImageRP from "@/components/ImageRP";
import { normalizePhone } from "@/helpers/normalizers";
import useCustomerPortal from "@/helpers/hooks/useCustomerPortal";
import { BRAND_CONST, USER_ROLE } from "@/config/constants";
import RpSvgIcon from "@/components/icons/RpSvgIcon";
import { capitalizeEachWord, getDashboardPath } from "@/helpers/utils";
import { ROUTES } from "@/helpers/routes/routePaths";
import ProfileActionIcon from "./ProfileActionIcon";

type ProfileCardUser = {
  email?: string;
  first_name?: string;
  last_name?: string;
  mobile_no?: string;
  profile_name?: string;
};

type ProfileCardBrand = {
  brand_name?: string;
  id?: number | string;
};

type ProfileCardSelectedBrand = {
  has_active_subscription_page?: boolean;
  id?: number | string;
};

const ProfileCard = ({
  loggedInUserRole,
  user = {},
  setCheckCurrentPass,
  setEdit,
  brand,
  selectedBrand,
}: {
  brand?: ProfileCardBrand;
  loggedInUserRole?: string;
  selectedBrand?: ProfileCardSelectedBrand;
  setCheckCurrentPass: (_value: boolean) => void;
  setEdit: (_value: boolean) => void;
  user?: ProfileCardUser;
}) => {
  const { navigateToCustomerPortal } = useCustomerPortal();
  const { first_name, last_name, email, mobile_no, profile_name } = user || {};
  return (
    <div
      className={`card profile-card ${loggedInUserRole === USER_ROLE.PARTICIPANT.NAME ? "profile-card-border" : ""}`}
    >
      <div className="card-header profile-card-header">
        <div className="profile-image-box">
          <div className="profile-image-container">
            <ImageRP
              className="profile-image"
              src={profile_name}
              type="PROFILE"
            />
          </div>
        </div>
      </div>

      <div className="card-body text-center profile-content">
        {/* hiding the unique id for PR */}
        {/* {loggedInUserRole === "PR" && (
          <div className="user-id-box mb-3">
            <div className="id">
              {`Unique ID : ${loggedInUser?.participantData?.system_generated_participant_id}`}
            </div>
          </div>
        )} */}
        <h2
          className={`user-name ${loggedInUserRole === USER_ROLE.PARTICIPANT.NAME ? "mb-1" : "mb-3"}  fw-b`}
        >
          {capitalizeEachWord(first_name)} {capitalizeEachWord(last_name)}
        </h2>
        {loggedInUserRole === USER_ROLE.PARTICIPANT.NAME && (
          <div className="mb-3">{brand?.brand_name}</div>
        )}
        <p className="user-email">
          <Icon
            className="icon"
            fontSize="small"
            component={RpSvgIcon}
            name="email"
            color="primary"
          />

          <span className="ml-1">{email}</span>
        </p>
        <p className="user-phone">
          <Icon
            className="icon"
            fontSize="small"
            component={RpSvgIcon}
            name="contact_icon"
            color="primary"
          />
          <span className="ml-1">
            {mobile_no ? normalizePhone(mobile_no) : "N/A"}
          </span>
        </p>

        <Button
          variant="contained"
          color="primary"
          component={Link}
          to={getDashboardPath()}
          fullWidth
          className="action-btn"
          startIcon={<LaptopOutlined fontSize="small" />}
        >
          Dashboard
        </Button>

        <Button
          variant="outlined"
          color="primary"
          startIcon={<ProfileActionIcon src="/img/icons/lock.svg" />}
          onClick={() => setCheckCurrentPass(true)}
          fullWidth
          className="action-btn"
        >
          Change Password
        </Button>

        <Button
          variant="outlined"
          color="primary"
          startIcon={<ProfileActionIcon src="/img/icons/profile_edit.svg" />}
          onClick={() => setEdit(true)}
          fullWidth
          className="action-btn"
        >
          Edit Profile
        </Button>

        {loggedInUserRole === USER_ROLE.PARTICIPANT.NAME &&
        selectedBrand?.has_active_subscription_page &&
        brand?.id === selectedBrand?.id ? (
          <div>
            <Button
              variant="outlined"
              color="primary"
              component={Link}
              to={ROUTES.SUBSCRIPTION_PACKAGES}
              fullWidth
              className="action-btn"
              startIcon={
                <ProfileActionIcon src="/img/icons/add_media_plan.svg" />
              }
            >
              Add Media Plan
            </Button>
            {selectedBrand?.id !== 1 && (
              <Button
                variant="outlined"
                color="primary"
                component={Link}
                to={ROUTES.MANAGE_SUBSCRIPTION}
                fullWidth
                className="action-btn"
                startIcon={
                  <ProfileActionIcon src="/img/icons/manage_active_plan.svg" />
                }
              >
                Manage Active Plans
              </Button>
            )}
          </div>
        ) : null}

        {selectedBrand?.id !== BRAND_CONST.MS_BRAND_ID &&
          selectedBrand?.id !== BRAND_CONST.KUMON_BRAND_ID &&
          loggedInUserRole === USER_ROLE.PARTICIPANT.NAME && (
            <Button
              variant="outlined"
              color="primary"
              onClick={navigateToCustomerPortal}
              fullWidth
              className="action-btn"
              startIcon={
                <ProfileActionIcon src="/img/icons/manage_payment.svg" />
              }
            >
              Manage Payments
            </Button>
          )}
      </div>
    </div>
  );
};

export default memo(ProfileCard);
